module.exports = __webpack_public_path__ + "static/media/the-daily-edition-section-header-logo.e062a22f.png";